import { default as Emoji } from '../../components/TUIChat/emoji-config/locales/zh_tw';
export default Emoji;
